import { searchAlertResults, searchAlertHitDetailsResults } from '@Services/AlertResults';
import { _resolveAuth, _goToQuickSearch } from './utils';

export const resolveUserAlert = _resolveAuth(async function resolveUserAlert(...args) {
  try {
    await searchAlertResults(...args);
  } catch(e) {
    _goToQuickSearch();
  }
});

export const resolveUserAlertHitDetails = _resolveAuth(async function resolveUserAlertHitDetails(...args) {
  try {
    await searchAlertHitDetailsResults(...args);
  } catch(e) {
    _goToQuickSearch();
  }
});
